import { defineComponent as _defineComponent } from 'vue'
import QrcodeVue from 'qrcode.vue'
import {computed, PropType} from "vue";
import type {AppSetting} from "@/components/customers/scripts/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCodeDialog',
  props: {
  qrCodeData: {
    required: true,
    type: String as PropType<string>
  },
  appSettings: {
    required: true,
    type: Object as PropType<AppSetting>
  },
  show: {
    required: false,
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  emits: [
  'onShowChange',
],
  setup(__props, { emit: emits }) {

const props = __props;




const showDialog = computed(() => props.show);

const changeShow = () => {
  emits('onShowChange', false)
}

return { __sfc: true,emits, props, showDialog, changeShow, QrcodeVue }
}

})